import { getJob } from "@stryker/core/api/jobs";
import { QueryKeys } from "@stryker/core/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";
import CreateUpdateJob from "@/pages/admin/compositeJob/CreateUpdateJob";
import CreateUpdateMechanicalJob from "@/pages/admin/mechanicalJob/CreateUpdateMechanicalJob";

export default function DraftEditJob() {
  const { id } = useParams();

  const { data: job, isLoading } = useQuery({
    queryKey: [QueryKeys.Job, id],
    queryFn: () => getJob(id as string),
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner svgClassName="h-20 w-20" />
      </div>
    );
  }

  if (!job) {
    return <div>Job not found</div>;
  }

  // Determine which component to render based on job type
  if (job.job_type === "mechanical") {
    return <CreateUpdateMechanicalJob />;
  } else {
    // Default to composite for "Composite Repairs" or any other type
    return <CreateUpdateJob />;
  }
}
